import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-task-priority-color',
    templateUrl: './task-priority-color.component.html',
    styleUrl: './task-priority-color.component.scss'
})
export class TaskPriorityColorComponent {

    @Input() public taskPriority = '';

}
